import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ProductCard from '../components/ProductCard';
import { productService } from '../services/productService';
import { LOCAL_CATEGORIES } from '../constants/localCategories';

const Shop = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const category = searchParams.get('category') || '';
  const [search, setSearch] = useState(searchParams.get('q') || '');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const res = await productService.getProducts({
        category: category || null,
        search: searchParams.get('q') || '',
      });
      if (res.success) setProducts(res.products);
      setLoading(false);
    };
    load();
  }, [category, searchParams]);

  const handleSearch = (e) => {
    e.preventDefault();
    const next = new URLSearchParams(searchParams);
    if (search.trim()) next.set('q', search.trim());
    else next.delete('q');
    setSearchParams(next);
  };

  return (
    <div>
      <Navbar />
      <div className="container" style={{ padding: '30px 20px' }}>
        <div style={{ marginBottom: 24 }}>
          <h1 style={{ marginBottom: 8 }}>Boutique locale Maxyfly</h1>
          <p style={{ color: '#666', maxWidth: 640 }}>
            Achetez des produits disponibles en RDC, sans passer par Shein, Amazon ou d&apos;autres
            plateformes internationales. Livraison locale incluse.
          </p>
          <p style={{ marginTop: 12 }}>
            <Link to="/order" className="btn btn-secondary" style={{ marginRight: 12 }}>
              Commander à l&apos;international
            </Link>
            <Link to="/cart" className="btn btn-primary">
              Voir le panier
            </Link>
          </p>
        </div>

        <form onSubmit={handleSearch} style={{ marginBottom: 20, display: 'flex', gap: 8 }}>
          <input
            type="search"
            placeholder="Rechercher un produit…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ flex: 1, padding: 12, borderRadius: 8, border: '1px solid #ddd' }}
          />
          <button type="submit" className="btn btn-primary">
            Rechercher
          </button>
        </form>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 24 }}>
          <button
            type="button"
            className={!category ? 'btn btn-primary' : 'btn btn-secondary'}
            onClick={() => setSearchParams({})}
          >
            Tous
          </button>
          {LOCAL_CATEGORIES.map((cat) => (
            <button
              key={cat.id}
              type="button"
              className={category === cat.id ? 'btn btn-primary' : 'btn btn-secondary'}
              onClick={() => {
                const next = new URLSearchParams(searchParams);
                next.set('category', cat.id);
                setSearchParams(next);
              }}
            >
              {cat.icon} {cat.label}
            </button>
          ))}
        </div>

        {loading ? (
          <p>Chargement des produits…</p>
        ) : products.length === 0 ? (
          <div className="card" style={{ padding: 40, textAlign: 'center' }}>
            <p style={{ fontSize: 48, marginBottom: 16 }}>🛍️</p>
            <p>Aucun produit pour le moment dans cette catégorie.</p>
            <p style={{ color: '#666', fontSize: 14 }}>
              Les agents et administrateurs peuvent publier des produits depuis la gestion catalogue.
            </p>
          </div>
        ) : (
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
              gap: 20,
            }}
          >
            {products.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Shop;
